// src\constants\home-section.constants.js
export const HIRE_ME_TEXT = `Let's Collabrate`;
export const CONTENT_STARTING_TEXT = `Hey, I'm`;
export const ROLE_STARTING_TEXT = `And I'm a`;
export const DESIGNATION_TEXT = `Full Stack Software Engineer`;
